<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="listcontainer mt20 clearfix">
        <div class="leftcon fl bgfff model1box p25">
          <h2 class="title">
            <span>商品信息</span>
            <a href="">返回</a>
          </h2>
          <div class="imgtxt mt20 clearfix">
            <div class="imgbox mr20">
              <img class="imgtop" :src="detail.image" alt="">
            </div>
            <ul class="txtul">
              <li><label>商品名称：</label><span>{{ detail.name }}</span></li>
              <li><label>所需积分：</label><span>{{ detail.price }}积分</span></li>
              <li v-if="detail.startTime !== undefined && detail.startTime !== ''"><label>有效日期：</label><span>{{ detail.startTime }} 至 {{ detail.endTime }}</span></li>
              <li v-if="detail.content !== ''"><label>商品介绍：</label><div v-html="detail.content"></div></li>
            </ul>
          </div>
          <h2 class="title mt50">
            <span>兑换信息</span>
          </h2>
          <div class="notification mt10"><i class="el-icon-bell mr10"></i>说明：请您在兑换成功后，我们的工作人员会在24小时内进行处理。请务必确保收件人，收件地址正确。</div>
          <el-form
            class="creditExchange mt20"
            ref="creditExchangeForm"
            :model="creditExchangeForm"
            :rules="creditExchangeFormRules">
            <el-form-item prop="userName" label="联系姓名">
              <el-input v-model="creditExchangeForm.userName" placeholder="请输入联系姓名"></el-input>
            </el-form-item>
            <el-form-item prop="contact" label="手机号码">
              <el-input v-model="creditExchangeForm.contact" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item prop="address" label="收件地址" class="w50">
              <el-input v-model="creditExchangeForm.address" placeholder="请输入收件地址"></el-input>
            </el-form-item>
            <el-form-item prop="remark" label="备注" class="w50">
              <el-input v-model="creditExchangeForm.remark" placeholder="请输入备注" type="textarea"></el-input>
            </el-form-item>
            <el-button type="primary" class="confirmbtn" @click="creditexchangefun">确认提交</el-button>
          </el-form>
        </div>
        <div class="rightcon fr">
          <creditrule/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { timeFormat } from '@/utils/validate'
import { getpointsmallDetail } from '@/api/pointsmall/index'
import { getuserpointcreditExchange } from '@/api/user/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import cfontSize from '@/components/selectfontsize/index'
import crumbs from '@/components/crumbs/index'
import creditrule from './creditrule'
export default {
  name: 'pointsmalldetail',
  meta: {
    showHeader: true
  },
  components: {
    Comment,
    RightSidebar,
    goTop,
    pv,
    cfontSize,
    crumbs,
    creditrule
  },
  data () {
    return {
      detail: '',
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      fontsizetype: '',
      creditExchangeForm: {
        commodityId: this.$route.query.id,
        userName: '',
        contact: '',
        address: '',
        remark: ''
      },
      creditExchangeFormRules: {
        userName: [{required: true, message: '请输入收件人名称', trigger: 'blur'}],
        contact: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
        address: [{required: true, message: '请输入收件地址', trigger: 'blur'}]
      }
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    fontsizeType (val) {
      this.fontsizetype = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 获取信息详情 */
    getDetail () {
      getpointsmallDetail(this.$route.query.id).then((res) => {
        console.log(res)
        if (res.data.status === 200) {
          this.detail = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    creditexchangefun () {
      this.$refs['creditExchangeForm'].validate((valid) => {
        if (valid) {
          getuserpointcreditExchange(this.creditExchangeForm).then(res => {
            console.log(res)
            if (res.data.rel) {
              this.$message({
                message: '兑换成功，请等待工作人员与您联系',
                type: 'success',
                duration: 1500
              })
              this.$refs.creditExchangeForm.resetFields()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.model1box{
  .title{
    font-size: 18px;
    display: flex;
    justify-content: space-between;
    padding: 0 0 15px;
    border-bottom: solid 1px #F2F2F2;
  }
  .imgtxt{
    display: flex;
    .imgbox{
      width: 240px;
      height: 160px;
    }
    .txtul{
      flex: 1;
      min-width: 0;
      li{
        margin: 2px 0 2px 0;
        label{
          color: #555;
        }
      }
    }
  }
}
/deep/ .el-form.creditExchange{
  .el-form-item__label{
    width: 80px;
    text-align: right;
  }
  .el-form-item__content{
    float: left;
  }
  .el-form-item.w50{
    .el-form-item__content{
      width: 50%;
    }
  }
  .confirmbtn{
    margin: 0 0 0 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pointsmall/pointsmalldetail.vue